import { defineStore } from "pinia";
import { ref, computed, watch } from "vue";
import Prompt from "@utils/Prompt";

import { validationCheck } from "@utils";

import { useSettings } from "@store/settings";

import { useRouter, useRoute } from "vue-router";

export const useCustomizer = defineStore("customizer", () => {
  const $settings = useSettings();
  const route = useRoute();
  const router = useRouter();

  const sidebarWidth = ref("350px");

  // const sidebarTime = ref({
  //     id: 'time',
  //     priority: $settings.customizer.time.priority,
  //     title: 'Time',
  //     link: { name: 'customizer.form.time' },
  //     visible: true,
  //     children: [
  //         { id: 'show_time', title: '24 Hours Time', selectedType: 'boolean', selected: $settings.customizer.time.show_time, component: 'Toggle' },
  //         { id: 'show_time_icon', title: 'Show Time Icon', selectedType: 'boolean', selected: $settings.customizer.time.show_time_icon, component: 'Toggle' },
  //     ]
  // })
  const sidebarTime = computed(
    () => sidebarFormMenu.value.find((item) => item.id == "time") || {}
  );
  const sidebarOverview = computed(
    () =>
      sidebarFormMenu.value.find((item) => item.id == "booking_overview") || {}
  );

  const sidebarFormMenu = ref([
    {
      id: "service",
      priority: $settings.customizer.service.priority,
      title: `${$settings.labels.service?.singular}`,
      link: { name: "customizer.form.service" },
      visible: true,
      children: [
        {
          id: "show_price",
          title: "Show Price",
          selectedType: "boolean",
          selected: $settings.customizer.service.show_price,
          component: "Toggle",
        },
        {
          id: "show_hours",
          title: "Show Duration",
          selectedType: "boolean",
          selected: $settings.customizer.service.show_hours,
          component: "Toggle",
        },
        {
          id: "show_image",
          title: "Show Image",
          selectedType: "boolean",
          selected: $settings.customizer.service.show_image,
          component: "Toggle",
        },
        {
          id: "layout_type",
          title: `${$settings.labels.service?.singular} Layout`,
          selectedType: "string",
          selected: $settings.customizer.service.layout_type,
          component: "IconsGroup",
          options: [
            { title: "Row 01", value: "row01", icon: "rows01" },
            { title: "Grid 01", value: "grid01", icon: "grid01" },
          ],
        },
      ],
    },
    {
      id: "staff",
      priority: $settings.customizer.staff.priority,
      title: $settings.labels.staff?.singular || "Staff",
      link: { name: "customizer.form.staff" },
      visible: $settings.addons.staffs,
      children: [
        {
          id: "show_image",
          title: "Show Image",
          selectedType: "boolean",
          selected: $settings.customizer.staff.show_image,
          component: "Toggle",
        },
        {
          id: "show_details",
          title: "Show Details",
          selectedType: "boolean",
          selected: $settings.customizer.staff.show_details,
          component: "Toggle",
          disabled: false,
        },
        {
          id: "layout_type",
          title: `${$settings.labels.staff?.singular} Layout`,
          selectedType: "string",
          selected: $settings.customizer.staff.layout_type,
          component: "IconsGroup",
          options: [
            { title: "Grid 04", value: "grid04", icon: "grid04" },
            { title: "Grid 01", value: "grid01", icon: "grid01" },
          ],
        },
      ],
    },
    {
      id: "date",
      priority: $settings.customizer.date.priority,
      title: "Date",
      link: { name: "customizer.form.date" },
      visible: true,
      children: [
        {
          id: "show_progress",
          title: "Show Progress",
          selectedType: "boolean",
          selected: $settings.customizer.date.show_progress,
          component: "Toggle",
        },
      ],
    },
    {
      id: "time",
      priority: $settings.customizer.time.priority,
      title: "Time",
      link: { name: "customizer.form.time" },
      visible: true,
      children: [
        {
          id: "show_time",
          title: "24 Hours Time",
          selectedType: "boolean",
          selected: $settings.customizer.time.show_time,
          component: "Toggle",
        },
        {
          id: "show_time_icon",
          title: "Show Time Icon",
          selectedType: "boolean",
          selected: $settings.customizer.time.show_time_icon,
          component: "Toggle",
        },
      ],
    },
    {
      id: "customer_information",
      priority: $settings.customizer.customer_information.priority,
      title: $settings.labels.customer?.singular || "Customer Information",
      link: { name: "customizer.form.account" },
      visible: true,
      children: [
        {
          id: "show_placeholder",
          title: "Show Placeholder",
          selectedType: "boolean",
          selected: $settings.customizer.customer_information.show_placeholder,
          component: "Toggle",
        },
      ],
    },
    {
      id: "booking_overview",
      priority: $settings.customizer.booking_overview.priority,
      title: `${$settings.labels.appointment?.singular} Overview`,
      link: { name: "customizer.form.overview" },
      visible: true,
      children: [
        {
          id: "show_staff",
          title: `Show ${$settings.labels.staff?.singular}`,
          selectedType: "boolean",
          selected: $settings.customizer.booking_overview.show_staff,
          component: "Toggle",
        },
        {
          id: "show_customer",
          title: `Show ${$settings.labels.customer?.singular}`,
          selectedType: "boolean",
          selected: $settings.customizer.booking_overview.show_customer,
          component: "Toggle",
        },
        {
          id: "show_address",
          title: "Show Address",
          selectedType: "boolean",
          selected: $settings.customizer.booking_overview.show_address,
          component: "Toggle",
        },
        {
          id: "show_payment_summary",
          title: `Show ${$settings.labels.payment?.singular} Summary`,
          selectedType: "boolean",
          selected: $settings.customizer.booking_overview.show_payment_summary,
          component: "Toggle",
        },
        {
          id: "show_payment_method",
          title: `Show ${$settings.labels.payment?.singular} Method`,
          selectedType: "boolean",
          selected: $settings.customizer.booking_overview.show_payment_method,
          component: "Toggle",
          visible: $settings.addons.payment,
        },
      ],
    },
  ]);

  const sidebarWidgetMenu = ref([
    {
      id: "general",
      title: "General",
      link: { name: "customizer.widget.general" },
      visible: true,
      children: [
        {
          id: "show_widget",
          title: "Show Widget",
          selectedType: "boolean",
          selected: false,
          component: "Toggle",
        },
      ],
    },
  ]);

  const defaultCustomizer = ref({
    service: {
      priority: 1,
      title: `Select ${$settings.labels.service?.singular}`,
      title_changed: false,
      show_price: true,
      show_hours: true,
      show_image: true,
      layout_type: "row01",
    },
    staff: {
      priority: 2,
      title: `Select ${$settings.labels.staff?.singular}`,
      title_changed: false,
      show_image: true,
      show_details: true,
      layout_type: "grid04",
    },
    date: {
      priority: 3,
      title: "Select Date",
      show_progress: true,
    },
    time: {
      priority: 4,
      title: "Select Time",
      show_time: true,
      show_time_icon: true,
      slot_subtitle: "Pick a time slot for",
      continue_button: "Continue",
    },
    customer_information: {
      priority: 5,
      title: "Enter information",
      subtitle: "Login or create an account if you are new here",
      show_placeholder: true,
      signup_title: "Create New Account",
      signup_firstname_label: "First Name",
      signup_lastname_label: "Last Name",
      signup_email_label: "Email",
      signup_phonenumber_label: "Phone",
      signup_password_label: "Password",
      login_title: "Login",
      login_email_label: "Email",
      login_password_label: "Password",
      login_button: "Login",
      signup_button: "Signup",
      signup_firstname_placeholder: "First name",
      signup_lastname_placeholder: "Last name",
      signup_email_placeholder: "you@gmail.com",
      signup_phonenumber_placeholder: "+1 (555) 000-0000",
      signup_password_placeholder: "Password",
      login_email_placeholder: "Your email address",
      login_password_placeholder: "Password",
    },
    booking_overview: {
      priority: 6,
      title: "Overview",
      show_staff: true,
      show_customer: true,
      show_address: true,
      show_payment_method: true,
      show_payment_summary: true,
    },
    sidebar: {
      show_background: false,
      background_type: "",
      background_colors: [
        "#004D65",
        "#012F7B",
        "#1A0A52",
        "#450D59",
        "#551029",
        "#831100",
        "#7B2900",
        "#7A4A00",
        "#6F760A",
        "#38571A",
        "#016E8F",
        "#0042A9",
        "#2C0977",
        "#61187C",
        "#791A3D",
        "#B51A00",
        "#AD3E00",
        "#A96800",
        "#9BA50E",
        "#4E7A27",
        "#008CB4",
        "#0056D6",
        "#371A94",
        "#7A219E",
        "#99244F",
        "#E22400",
        "#DA5100",
        "#D38301",
        "#C3D117",
        "#669D34",
        "#00A1D8",
        "#0061FD",
        "#4D22B2",
        "#982ABC",
        "#B92D5D",
        "#FF4015",
        "#FF6A00",
        "#FFAB01",
        "#D9EC37",
        "#76BB40",
        "#01C7FC",
        "#3A87FD",
        "#5E30EB",
        "#BE38F3",
        "#E63B7A",
        "#FE6250",
        "#FD920F",
        "#FFBD07",
        "#E4EF65",
        "#96D35F",
        "#52D6FC",
        "#74A7FF",
        "#7F56D9",
        "#D357FE",
        "#EE719E",
        "#FF8C82",
        "#FEA57D",
        "#FEC777",
        "#EAF28F",
        "#B1DD8B",
        "#FFFEFE",
        "#474747",
        "#333333",
        "#000000",
      ],
      background_color: "#7F56D9",
      background_image: "",
      content_position: "Left top",
      business_name_color: "#101828",
      business_about_color: "#475467",
      business_custom_logo: "",
      business_custom_name: "",
      business_custom_about: "",
      provider_display_name: "",
      provider_bio: "",
      provider_display_name_color: "#101828",
      provider_bio_color: "#475467",
    },
    design: {
      brand_color: "#7F56D9",
      corner_style: "Rounded",
      font_family: "Plus Jakarta Sans",
      typography_title_font_color: "#101828",
      typography_title_font_weight: "SemiBold",
      typography_subtitle_font_color: "#101828",
      typography_subtitle_font_weight: "SemiBold",
      input_border_color: "#d0d5dd",
      input_border_style: "Border",
      button_text_font_color: "#ffffff",
      button_text_font_weight: "SemiBold",
      button_background_color: "#7F56D9",
      button_background_style: "Filled",
      button_border_radius: 8,
    },
  });

  // return object from sidebar menu array.children
  const getMenuStatusById = (parentId, childrenId) => {
    if (!parentId || !childrenId) return false;

    let menu = [...sidebarFormMenu.value, ...sidebarWidgetMenu.value];

    let item = menu
      .find((menu) => menu.id == parentId)
      .children.find((menu) => menu.id == childrenId);

    if (!item.selected) {
      switch (item.selectedType) {
        case "boolean":
          return false;
        case "string":
          return "";
        default:
          return false;
      }
    }

    return item.selected;
  };

  const isCustomizerChanged = ref(false);

  watch(
    () => $settings.customizer,
    () => {
      isCustomizerChanged.value = true;
    },
    { deep: true }
  );

  const isCustomizerInputChanged = async () => {
    if (isCustomizerChanged.value) return;

    if (localStorage.getItem("customizer") !== JSON.stringify(customizer))
      return (isCustomizerChanged.value = true);
  };

  const cancel = async (reload = false) => {
    await isCustomizerInputChanged();
    const onSuccess = () => {
      if (reload)
        return (window.location.href = `${prebook_admin.url.home}${prebook_admin.url.current}#/customizer`);

      router.push({ name: "customizer" });
    };

    if (!isCustomizerChanged.value) return onSuccess();

    const choice = await Prompt.fire({
      title: "Unsaved Changes Detected",
      message: `You have unsaved changes. Any unsaved changes will be lost. <br> Are you sure you want to continue?`,
      ok: "Yes, proceed",
      cancel: "No, cancel",
    });

    if (choice.ok) {
      onSuccess();
    }
  };

  const publish = async () => {
    await isCustomizerInputChanged();
    // console.log($settings.customizer.sidebar.background_image == "")

    // $settings.customizer.sidebar.business_name_color

    // validation
    let { errors } = validationCheck([
      {
        condition:
          $settings.addons.staffs &&
          !$settings.customizer.sidebar.business_custom_name,
        message: "Business name is required",
      },
      {
        condition:
          !$settings.addons.staffs &&
          !$settings.customizer.sidebar.provider_display_name,
        message: "Provider display name is required",
      },
    ]);

    if (errors) return;

    // check service/staff title change
    if (
      $settings.settings.customizer.service.title !=
      `Select ${$settings.labels.service?.singular}`
    ) {
      $settings.settings.customizer.service.title_changed = true;
    }

    if (
      $settings.settings.customizer.staff.title !=
      `Select ${$settings.labels.staff?.singular}`
    ) {
      $settings.settings.customizer.staff.title_changed = true;
    }

    if (
      $settings.customizer.sidebar.background_type == "image" &&
      $settings.customizer.sidebar.background_image == ""
    ) {
      $settings.customizer.sidebar.background_type = "color";

      router.replace({
        name: route.name,
        query: { ...route.query, background: "color" },
      });
    }

    await $settings.saveSettings("customizer");
    await syncWithChatCustomizer();
    console.log("publish", $settings.customizer);

    // reset customizer history
    isCustomizerChanged.value = false;
    localStorage.setItem("customizer", JSON.stringify($settings.customizer));

    Toast.success("Customizer updated successfully");
  };

  const resetCustomizer = async () => {
    let choice = await Prompt.fire({
      title: "Warning: Reset Booking Form!",
      message: `This will reset the form to its original state. <br> All your changes will be lost. There's no going back! `,
      ok: "Yes, proceed",
      cancel: "No, cancel",
    });

    if (choice.ok) {
      // reset customizer
      $settings.settings.customizer = defaultCustomizer.value;

      // update customizer settings
      await $settings.saveSettings("customizer");

      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  };

  const syncWithChatCustomizer = async () => {
    console.log("Syncing with chat customizer");
    $settings.settings.chat_widget.account.priority =
      $settings.customizer.customer_information.priority;
    $settings.settings.chat_widget.date.priority =
      $settings.customizer.date.priority;
    $settings.settings.chat_widget.service.priority =
      $settings.customizer.service.priority;
    $settings.settings.chat_widget.staff.priority =
      $settings.customizer.staff.priority;
    $settings.settings.chat_widget.time.priority =
      $settings.customizer.time.priority;
    await $settings.saveSettings("chat-widget");
  };

  const isRounded = computed(() => {
    return $settings.customizer.design.corner_style == "Rounded" ? true : false;
  });

  const getFontWeight = (fontWeight) => {
    switch (fontWeight) {
      case "Regular":
        return "400";
      case "Medium":
        return "500";
      case "SemiBold":
        return "600";
      case "Bold":
        return "700";
      default:
        return "500";
    }
  };

  const titleStyle = computed(() => {
    return `font-weight:${getFontWeight(
      $settings.customizer.design.typography_title_font_weight
    )} !important; color:${
      $settings.customizer.design.typography_title_font_color
    } !important;`;
  });

  const subtitleStyle = computed(() => {
    return `font-weight:${getFontWeight(
      $settings.customizer.design.typography_subtitle_font_weight
    )} !important; color:${
      $settings.customizer.design.typography_subtitle_font_color
    } !important;`;
  });

  const buttonStyle = computed(() => {
    return `font-weight:${getFontWeight(
      $settings.customizer.design.button_text_font_weight
    )} !important; color:${
      $settings.customizer.design.button_text_font_color
    } !important; border-radius:${
      $settings.customizer.design.button_border_radius
    }px !important; border: 1px solid ${
      $settings.customizer.design.button_background_color
    } !important; background-color:${
      $settings.customizer.design.button_background_style == "Filled"
        ? $settings.customizer.design.button_background_color
        : "transparent"
    } !important;`;
  });

  return {
    sidebarWidth,
    sidebarTime,
    sidebarFormMenu,
    getMenuStatusById,
    cancel,
    publish,
    sidebarWidgetMenu,
    isRounded,
    titleStyle,
    subtitleStyle,
    buttonStyle,
    resetCustomizer,
    isCustomizerChanged,
    sidebarOverview,
  };
});
